import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { useTheme } from '@material-ui/core/styles';
import { readableHeading } from '../readablePalette';

const ClosingPitch = () => {
  const theme = useTheme();
  const h = readableHeading(theme);

  return (
    <Box marginY={4}>
      <Typography variant="overline" sx={{ fontWeight: 700, letterSpacing: '0.14em', color: theme.palette.secondary.main }}>
        Argumento para la junta directiva
      </Typography>
      <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 700, fontFamily: 'Georgia, serif', color: h, mt: 0.5 }}>
        Donde está la gente, debe estar el Colegio
      </Typography>
      <Box
        component="blockquote"
        sx={{
          m: 0,
          mt: 2,
          pl: 3,
          borderLeft: `4px solid ${theme.palette.secondary.main}`,
          fontStyle: 'italic',
        }}
      >
        <Typography variant="h6" component="p" color="textPrimary" sx={{ fontWeight: 500, lineHeight: 1.65 }}>
          «El Colegio no solo debe estar en los tribunales: debe estar donde está la gente. TNO Network ofrece la vitrina
          perfecta para humanizar al abogado, promover la formación continua y demostrarle a la sociedad que el Ilustre
          Colegio de Abogados del Distrito Capital es el máximo garante de la justicia y la ética en nuestra ciudad.»
        </Typography>
      </Box>
    </Box>
  );
};

export default ClosingPitch;
